<template>
  <div>
    <div class="heaer-text">全部维度报表</div>
    <div class="table-wrap">
      <demension-filter
        @refreshTable="refreshTable"
        @downloadFile="downloadFile"
      ></demension-filter>
      <demension-table
        ref="usertable"
        :column="column"
        :list="list"
        :loading="loading"
      ></demension-table>
    </div>
  </div>
</template>
<script>
import demensionFilter from "./demensionFilter.vue";
import demensionTable from "./demensionTable.vue";
import { column } from "./data";
import { getalldimensiondataFetch } from "@/api/api";
export default {
  name: "alldimensionsreport",
  components: { demensionFilter, demensionTable },
  data() {
    return {
      loading: false,
      column: column,
      list: [],
    };
  },
  methods: {
    downloadFile() {
      this.$refs.usertable.downLoadFileToExcel();
    },
    refreshTable(param) {
      this.getData(param);
    },
    getData(param) {
      this.loading = true;
      getalldimensiondataFetch({ data: JSON.stringify(param) })
        .then((res) => {
          console.log(res);
          this.loading = false;
          const { code, collecs, msg } = res;
          if (code == "0000") {
            this.list = collecs;
          } else {
            this.$message({
              message: msg,
              type: "error",
            });
          }
        })
        .catch((e) => {
          this.loading = false;
          throw new Error(e);
        });
    },
  },
};
</script>
<style scoped>
.heaer-text {
  padding: 16px 16px 6px 16px;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: bold;
}
.table-wrap {
  padding: 15px;
}
</style>
